<template>
    <div class="header">
        <div class="header_left">
            <div class="logo">
                <!-- <img src="../../../assets/plant/logo.png"> -->
            </div>
            <el-tooltip effect="dark" content="系统首页" placement="bottom">
                <div class="btn_home" @click="goHome"><i class="iconfont">&#xe655;</i></div>
            </el-tooltip>
        </div>
        <div class="header_right">
            <ul>
                <li class="user_info">
                    <img src="assets/plant/img.png">
                    <span>{{username}}</span>
                </li>
                <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
                    <li @click="handleFullScreen">
                        <i class="iconfont">&#xe62a;</i>
                    </li>
                </el-tooltip>
                <li class="logout_item">
                    <el-button
                        size="mini"
                        type="danger"
                        plain
                        icon="el-icon-switch-button"
                        @click="handleLogout"
                    >
                        退出登录
                    </el-button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    // import bus from './Eventbus';
    export default {
        data() {
            return {
                collapse: true,
                fullscreen: false,
                message: 2
            }
        },
        computed: {
            username() {
                let username = localStorage.getItem('ms_username');
                return username;
            }
        },
        methods: {
            // 侧边栏折叠
            collapseChage() {
                this.collapse = !this.collapse;
                // bus.$emit('collapse', this.collapse);
            },

            // 全屏事件
            handleFullScreen() {
                let element = document.documentElement;
                if (this.fullscreen) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.webkitRequestFullScreen) {
                        element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.msRequestFullscreen) {
                        // IE11
                        element.msRequestFullscreen();
                    }
                }
                this.fullscreen = !this.fullscreen;
            },

            //go home
            goHome(){
                this.$router.push("/dashboard");
            },

            //退出登录
            handleLogout(){
                this.$confirm('确认退出登录？','提示',{
                    confirmButtonText: '退出',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    this.clearLoginCache();
                    this.$message.success('已退出登录');
                    this.$router.push('/login');
                })
                .catch(() => {});
            },

            clearLoginCache() {
                const keys = [
                    'ms_username',
                    'ms_userId',
                    'ms_lastLoginTime',
                    'ms_greenhouseId',
                    'userId',
                    'userName',
                    'avatar',
                    'codeType',
                    'courseId',
                    'codingRecordId',
                    'assignmentId',
                    'videoCourseId',
                    'videoAssignmentId'
                ];
                keys.forEach(key => localStorage.removeItem(key));
            }
        },
        mounted() {
            if (document.body.clientWidth < 1500) {
                this.collapseChage();
            }
        }
    }
</script>

<style lang="scss" scoped>
    // @import "../../../../public/css/common";
    .header{
        display: -webkit-flex;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        background-color: #ffffff;
        border-bottom: 1px solid #DAE3F2;
        .iconfont{
            font-size: 20px;
            color: #67C23A;
        }
        .header_right{
            height: 100%;
            ul{
                height: 100%;
                li{
                    height: 100%;
                    line-height: 60px;
                    min-width: 80px;
                    float: left;
                    text-align: center;
                    cursor: pointer;
                    border-left: 1px solid #DAE3F2;
                    &:first-child{
                        cursor: inherit;
                        border-left:none;
                        padding: 0 20px;
                    }
                }
            }
        }
        .user_info{
            img{
                width: 40px;
                height: 40px;
                float: left;
                margin:10px 10px 0 0;
            }
        }
        .logout_item{
            display: flex;
            align-items: center;
            padding: 0 12px;
            .el-button{
                border-color: #f56c6c;
                color: #f56c6c;
            }
        }
        .header_left{
            display: -webkit-flex;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .btn_home{
                width: 80px;
                height: 100%;
                line-height: 60px;
                text-align: center;
                border-right: 1px solid #DAE3F2;
                cursor: pointer;
            }
            .logo{
                width: 160px;
                height: 60px;
                background-color: #67C23A;
                img{
                    margin: 0 auto;
                }
            }
        }
    }

</style>
